import Vue from 'vue'
import {EventBus, EventBusType} from '@/services/eventbus'
import router from "@/router";
import i18n from "@/plugins/i18n";
import moment from "moment";
import $filters from "@/filters/filters";

const AppService = {
    promiseMap: {},
    createToastLink (message, bot_code, sender_id) {
        return `<div style="display: flex; align-items: center; width: 100%; flex-wrap: wrap">
            <div>${message}</div>
            <div style="flex: 1 1 1px"></div>
            <div class="notify-btn" onclick="goToChannel('${bot_code}', '${sender_id}')">
                ${i18n.t('open')}
            </div>
        </div>`
    },
    toast (message, type, duration = 2000) {
        // Khong notify khi dang o trang dashboard-realtime
        if (router.currentRoute.path.includes("dashboard-realtime"))
            return;
        EventBus.$emit(EventBusType.TOAST, {
            group: 'app',
            title: '',
            text: message,
            duration: duration,
            type: type,
            ignoreDuplicates: true
        })
    },
    toastSuccess (message) {
        this.toast(message, 'success')
    },
    toastError (message) {
        this.toast(message, 'error')
    },
    toastInfo (message) {
        this.toast(message, 'info')
    },
    hideLoading () {
    },
    handleRequestError (alternateErrorMessage, hideLoading = false) {
        return error => {
            if (hideLoading) {
                this.hideLoading()
            }
            if (error.data) {
                let data = error.data;
                let errorMessage = '';
                if (Array.isArray(data)) {
                    errorMessage = data.join('')
                } else if (typeof data === 'object') {
                    if (data.message) {
                        errorMessage = data.message
                    }
                }
                this.toastError(errorMessage)
            } else if (alternateErrorMessage) {
                this.toastError(alternateErrorMessage)
            } else {
                this.toastError('error')
            }
        }
    },
    async osNotify (message, botCode, senderId, uniqTag = '') {
        if (!("Notification" in window)) {
            // This browser does not support desktop notification
            return;
        }
        if (Notification.permission !== "granted") {
            await Notification.requestPermission();
        }
        if (Notification.permission === "granted") {
            let notification = new Notification('FPT.AI LiveSupport', {
                icon: '/favicon.ico',
                body: message,
                tag: uniqTag, // https://developer.mozilla.org/en-US/docs/Web/API/Notification/tag
            });
            notification.onclick = () => {
                window.focus();
                if (window.opener) {
                    window.opener.focus();
                }
                router.push(`/bot/${botCode}/s/${senderId}`)
            }
        }
    },
    createTextImage (name, max = 2) {
        if (!name) {
            return '';
        }
        let split = name.split(' ');
        if (split.length < 2) {
            return name.length < max ? name.toUpperCase() : name.substring(0, max).toUpperCase();
        }
        let shortName = '';
        let length = split.length > max ? max : split.length;
        for (let i = 0; i < length; i++) {
            shortName += split[i].charAt(0);
        }
        return shortName.toUpperCase();
    },
    getLocale () {
        return window.vueapp.$i18n.locale.split('-')[0]
    },
    buildTimeQuery (fromDate, toDate) {
        let _fromDate = moment.utc(moment(`${fromDate} 00:00:00`)).format('YYYY-MM-DD HH:mm:ss');
        let _toDate = moment.utc(moment(`${toDate} 23:59:59`)).format('YYYY-MM-DD HH:mm:ss')
        return `from=${_fromDate}&to=${_toDate}`
    },
    confirm (message) {
        EventBus.$emit(EventBusType.CONFIRM, message)
        return new Promise((resolve, reject) => {
            AppService.promiseMap[EventBusType.CONFIRM] = { resolve, reject }
        })
    },
    correctHeaders (headers) {
        for (let header of headers) {
            header.text = $filters.capitalize(header.text)
            header.sortable = header.sortable | false
        }
        return headers
    },
};

EventBus.$on(EventBusType.CONFIRM_DONE, confirm => {
    AppService.promiseMap[EventBusType.CONFIRM].resolve(confirm)
})

Vue.prototype.$AppService = AppService;
Vue.prototype.$appService = AppService;

export default AppService
